






















































import { computed, defineComponent, ref, watch, inject } from "@vue/composition-api";
import { MessageLinkSubject } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { handleRequestError } from "@/lib/handleRequestError";
import { getCurrencySymbol, getMainCurrencyCode } from "@/lib/moneyHelpers";
import config from "@/config";
import { ERRORS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInput from "@/components/BaseInput";
import BaseSendMessage from "@/components/BaseSendMessage";
import PaidActionError from "@/components/PaidActionError";

export default defineComponent({
  name: "TipController",
  components: { BaseSendMessage, BaseInput, BaseButton, BaseIcon, BaseIconButton, PaidActionError },
  props: {
    threadId: { type: String },
    transparent: { type: Boolean, default: false },
    linkSubject: { type: Object as () => MessageLinkSubject },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const data = inject<{ user: UserPublicData | null }>("messageData", { user: null });
    const show = ref(false);
    const tipValue = ref("");
    const processing = ref(false);
    const currencySymbol = getCurrencySymbol(getMainCurrencyCode());
    const showPaidError = ref(false);

    const userId = computed(() => data.user?.id ?? "");
    const allowSend = computed(() => tipValue.value.length !== 0 && +tipValue.value > 0);
    const openerIcon = computed(() => (show.value ? "sci-close" : "sci-tip"));
    const activateTip = computed(
      () =>
        checkRole(authUser.value?.role || "", config.userRegistrationRole) &&
        config.featureTipping &&
        checkRole(data.user?.role || "", "creator") &&
        data.user?.verified &&
        !data.user.partner
    );

    const toggleShow = () => (show.value = !show.value);
    const reset = () => (tipValue.value = "");

    const tipValueInput = (v: string) => {
      let value = v.replace(",", ".");
      if (isNaN(+value) || +value === 0) {
        value = "";
      }
      tipValue.value = value;
    };

    const submit = async () => {
      if (!userId.value || !allowSend.value) return;
      try {
        processing.value = true;
        const tipAmount = tipValue.value;
        providers.TipProvider.setReceiveErrors(false);
        await providers.TipProvider.create({
          data: {
            recipientId: userId.value,
            amount: +tipAmount,
            threadId: props.threadId,
            linkSubject: props.linkSubject,
          },
        });
        emit("success");
        reset();
        show.value = false;
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
            onSuccessCB: () => (showPaidError.value = true),
          },
        ]);
      } finally {
        processing.value = false;
      }
    };

    watch(show, () => reset());
    return {
      currencySymbol,
      tipValue,
      allowSend,
      processing,
      activateTip,
      openerIcon,
      show,
      showPaidError,
      reset,
      tipValueInput,
      submit,
      toggleShow,
    };
  },
});
